import { useEffect, useRef } from 'react';
import LoadingBarReact from 'react-top-loading-bar';

export default function LoadingBar({router}){

    const ref = useRef(null);

    useEffect(() => {
    
        if(ref.current){
            ref.current.continuousStart();
        }

        const timer = setTimeout(() => {
            if(ref.current){
                ref.current.complete();
            }
        }, 400);
    
        return () => clearTimeout(timer);
      
  }, [router?.pathname]); 

    return (
        <LoadingBarReact
            ref={ref}
            color="#2196F3"
            height={3}
            shadow={true}
            waitingTime={100}
        />
    );
    
};